export class WPublishedPageModel {
  constructor(
    public pageNum: string,
    public pageInfo: string,
    public komaId: string,
    public parentChildDiv: string,
    public id: number
  ) { }
}